import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getPartnerInfoByIdSlice = createSlice({
    name: "getPartnerInfoById",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getPartnerInfoByIdSlice_actions = getPartnerInfoByIdSlice.actions;
export var fetchData = _getPartnerInfoByIdSlice_actions.fetchData, fetchDataSuccess = _getPartnerInfoByIdSlice_actions.fetchDataSuccess, fetchDataFailure = _getPartnerInfoByIdSlice_actions.fetchDataFailure, resetState = _getPartnerInfoByIdSlice_actions.resetState;
export default getPartnerInfoByIdSlice.reducer;
